import { getSpApi, pagedRequestConfig, requestConfig } from "./apiRoot";
import { UrlManager } from "./UrlManager";

type PackagesQueryParameters = Paths.ApiDocumentPackagetosign.Get.QueryParameters;

export const getPackages = async (
    requestParams: PackagesQueryParameters = {},
): Promise<MyBrokerApi.DocumentsPackageToSignPayload> => {
    const axiosRequestConfig = pagedRequestConfig<PackagesQueryParameters>({ params: requestParams });

    const { data } = await getSpApi().get<MyBrokerApi.DocumentsPackageToSignPayload>(
        UrlManager.documentsPackages(),
        axiosRequestConfig,
    );
    return data;
};

export const getConnectiveUrl = async (
    id: string,
): Promise<Paths.ApiDocumentPackagetosign$IdUrl.Get.Responses.$200> => {
    const params = {};

    const axiosRequestConfig = requestConfig(params);

    const { data } = await getSpApi().get<Paths.ApiDocumentPackagetosign$IdUrl.Get.Responses.$200>(
        UrlManager.documentsPackageUrl(id),
        axiosRequestConfig,
    );
    return data;
};
